import type { CreateRelationshipRequest } from "@family/shared";

/**
 * How a newly added person relates to someone already in the tree, phrased
 * from the new person's side — "child of X", not the storage form.
 *
 * relationships rows for kind="parent" run child -> parent, which is the
 * wrong way round for anyone filling in a form about a newborn, and getting
 * it backwards silently inverts a branch of the tree. Kept out of the form
 * component so the mapping can be tested on its own.
 */
export const RELATION_OPTIONS = [
  { value: "child", label: "child of" },
  { value: "parent", label: "parent of" },
  { value: "spouse", label: "married to" },
  { value: "sibling", label: "sibling of" },
] as const;

export type RelationChoice = (typeof RELATION_OPTIONS)[number]["value"];

export function edgeFor(
  choice: RelationChoice,
  newPersonId: string,
  otherId: string,
): CreateRelationshipRequest {
  switch (choice) {
    case "child":
      return { fromPerson: newPersonId, toPerson: otherId, kind: "parent" };
    case "parent":
      return { fromPerson: otherId, toPerson: newPersonId, kind: "parent" };
    case "spouse":
      return { fromPerson: newPersonId, toPerson: otherId, kind: "spouse" };
    case "sibling":
      return { fromPerson: newPersonId, toPerson: otherId, kind: "sibling" };
  }
}
